export default function EmptyState({ icon, title, hint }) {
  return (
    <div className="flex flex-col items-center justify-center py-24 text-center">
      {icon}
      <p className="mt-4 text-lg font-semibold text-mist-400">{title}</p>
      {hint && <p className="mt-1 text-sm text-mist-500">{hint}</p>}
    </div>
  )
}
